import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./components/Landing";
import AuthPage from "./components/AuthPage";
import Onboarding from "./components/Onboarding";
import AthleteHome from "./components/AthleteHome";
import CoachHome from "./components/CoachHome";
import Pricing from "./components/Pricing";
import PaymentSuccess from "./components/PaymentSuccess";
import ResetPassword from "./components/ResetPassword";
import Legal from "./components/Legal";
import Privacy from "./components/Privacy";
import Settings from "./components/Settings";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "coach" ? "/coach" : "/app"} replace />;
  return children;
}

function HomeRoute() {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  if (user && user.role === "coach") return <Navigate to="/coach" replace />;
  if (user) return <Navigate to="/app" replace />;
  return <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/onboarding" element={<Protected role="athlete"><Onboarding /></Protected>} />
            <Route path="/app" element={<Protected role="athlete"><AthleteHome /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/coach" element={<Protected role="coach"><CoachHome /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
